import Config from "../../config/Config";
const axios = require("axios");

const baseUrlDev = Config.BaseUrlMedicalRecordDev;
const bearer = () => {
  return localStorage.getItem("token_redux").replaceAll('"', "");
};
export const getDataMedicalRecord = (query: string) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrlDev}parent${query}`, {
        headers: {
          Authorization: `Bearer ${bearer()}`,
        },
      })
      .then((res) => {
        let token = res.headers.authorization;
        if (!res.headers.authorization) {
          token = localStorage.getItem("token_redux");
        }
        if (token) {
          if (!token.includes("Bearer")) {
            token = token.replaceAll("Bearer ", "");
          }
          localStorage.setItem("token_redux", token.replaceAll("Bearer ", ""));
        }
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getDataMedicalRecordDetail = (id: string) => {
  return axios.get(`${baseUrlDev}parent/${id}`, {
    headers: {
      Authorization: `Bearer ${bearer()}`,
    },
  });
};
